import { Component, inject, input } from '@angular/core';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { Brand } from '~core/models/brand.models';
import { BrandCreationDialogComponent } from '../../modals/brand-creation-dialog/brand-creation-dialog.component';
import { DeleteConfirmComponent } from '~app/app/~shared/components/modals/delete-confirm/delete-confirm.component';
import { BrandService } from '~app/app/~shared/services/brand.service';
import { filter, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { BrandDetailsComponent } from '../brand-details/brand-details.component';

@Component({
  selector: 'brand-list-datatable',
  templateUrl: './brand-list-datatable.component.html',
  styleUrl: './brand-list-datatable.component.scss'
})
export class BrandListListDatatableComponent extends BaseComponent {
  brands = input<Brand[]>([]);

  private _dialogService = inject(DialogService);
  private _brandService = inject(BrandService);
  private _resourceFacade = inject(ResourceFacade);

  displayedColumns: string[] = [
    'name',
    'group',
    'sector',
    'subSector',
    'actions'
  ];

  onRowClick(brands: Brand): void {
    const dialogRef = this._dialogService.open({
      component: BrandDetailsComponent,
      config: {
        panelClass: ['mat-dialog-custom', 'w-[600px]'],
        backdropClass: ['bg-black/50'],
        disableClose: false,
        maxWidth: '600px'
      }
    });
    dialogRef.componentRef?.setInput('brands', brands);
  }

  onEdit(brand: Brand): void {
    const dialogRef = this._dialogService.open({
      component: BrandCreationDialogComponent,
      fullscreen: true
    });

    dialogRef.componentRef?.setInput('brand', brand);
  }

  onDelete(brand: Brand): void {
    const delete$ = this._brandService.remove(brand.id);

    const dialogRef = this._dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentInstance.removeObservable$ = delete$;
    dialogRef.componentRef?.setInput(
      'title',
      `Voulez-vous supprimer la marque "${brand.name}" ?`
    );

    dialogRef
      .afterClosed()
      .pipe(
        filter(Boolean),
        takeUntilDestroyed(this._destroyRef),
        tap({
          next: () => {
            this._resourceFacade.getData({ refresh: true });
            this._snackbarService.open({
              text: 'Marque supprimée avec succès',
              type: 'success'
            });
          }
        })
      )
      .subscribe();
  }
}
